export const TEST_ID = 'batterySerialNumberField';
